import styled from "styled-components";

interface ITop {
  hasmargintop?: boolean;
}

export const Top = styled.div<ITop>`
  width: 100%;
  height: auto;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  padding-bottom: 6px;
  margin-top: ${({hasmargintop}) => hasmargintop ? 24 : 0}px;

  .title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }
`;

export const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;
